import React from 'react';

import { maskitoDateTimeOptionsGenerator } from '@maskito/kit';
import { useMaskito } from '@maskito/react';
import { Calendar as CalendarIcon } from 'lucide-react';

import { Button } from '../../components/ui/button';
import { Calendar } from '../../components/ui/calendar';
import { useMediaQuery } from '../../hooks/use-media-query.jsx';
import { cn } from '../../utils/cn.js';

import {
  Dialog,
  DialogContent,
  DialogDescription,
  DialogHeader,
  DialogTitle,
  DialogTrigger,
} from './dialog.jsx';
import {
  Drawer,
  DrawerContent,
  DrawerDescription,
  DrawerHeader,
  DrawerTitle,
  DrawerTrigger,
} from './drawer.jsx';
import { Input } from './input.jsx';
import { Separator } from './separator.jsx';
import { TimePicker } from './time-picker.jsx';

const dateTimeOptions = maskitoDateTimeOptionsGenerator({
  dateMode: 'dd/mm/yyyy',
  timeMode: 'HH:MM:SS',
  dateSeparator: '-',
  dateTimeSeparator: ' ',
});

const DateTimeInput = ({ input }) => {
  const maskedInputRef = useMaskito({ options: dateTimeOptions });

  return (
    <Input
      {...input}
      variant="outline"
      className={cn(
        'w-full justify-start text-left font-normal disabled:opacity-75',
        input?.className,
      )}
      onInput={input?.onChange}
      ref={maskedInputRef}
      placeholder="dd-MM-yyyy HH:mm:ss"
    />
  );
};

const PickerContent = ({ calendar }) => (
  <div className="flex w-auto flex-col items-center justify-center gap-4 p-0">
    <Calendar {...calendar} />

    <Separator />

    <TimePicker setDate={calendar?.onSelect} date={calendar?.selected} />
  </div>
);

export function DateTimeInputWithDatePicker({ input, calendar }) {
  const isDesktop = useMediaQuery('(min-width: 768px)');

  if (isDesktop) {
    return (
      <div className="relative w-full">
        <DateTimeInput input={input} />
        <Dialog>
          <DialogTrigger asChild>
            <Button
              type="button"
              variant="ghost"
              className="absolute right-3 top-[50%] h-auto translate-y-[-50%] rounded-lg p-1.5"
            >
              <CalendarIcon className="size-4" />
            </Button>
          </DialogTrigger>
          <DialogContent className="w-auto">
            <DialogHeader>
              <DialogTitle>Calendário</DialogTitle>
              <DialogDescription>Escolha uma data e hora</DialogDescription>
            </DialogHeader>
            <PickerContent calendar={calendar} />
          </DialogContent>
        </Dialog>
      </div>
    );
  }

  return (
    <div className="relative w-full">
      <DateTimeInput input={input} />
      <Drawer>
        <DrawerTrigger asChild>
          <Button
            type="button"
            variant="ghost"
            className="absolute right-3 top-[50%] h-auto translate-y-[-50%] rounded-lg p-1.5"
          >
            <CalendarIcon className="size-4" />
          </Button>
        </DrawerTrigger>
        <DrawerContent className="pb-8">
          <DrawerHeader>
            <DrawerTitle>Calendário</DrawerTitle>
            <DrawerDescription>Escolha uma data e hora</DrawerDescription>
          </DrawerHeader>
          <PickerContent calendar={calendar} />
        </DrawerContent>
      </Drawer>
    </div>
  );
}
